export class LoginFormModel {
    constructor(
        public login: string = '',
        public senha: string = ''
    ){
        this.login = login;
        this.senha = senha;
    }
}